import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import Layout from "./components/Layout";
import Routes from "./routes";
import PageLoader from "./components/PageLoader";

function App() {
  const theme = createTheme({
    palette: {
      mode: "dark",
      background: {
        default: "#000",
        paper: "#000",
      },
      primary: {
        light: "#74e7b9",
        main: "#3eb489",
        dark: "#00835c",
        contrastText: "#fff",
      },
      secondary: {
        light: "#ffd64a",
        main: "#ffa500",
        dark: "#c67600",
        contrastText: "#000",
      },
    },
    typography: {
      fontFamily: `"Poppins", "Roboto", "Helvetica", "Arial", sans-serif`,
      fontSize: 18,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundColor: "#000",
          },
        },
      },
    },
    mixins: {
      toolbar: {
        minHeight: 104,
      },
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <PageLoader></PageLoader>
      <BrowserRouter>
        <Layout>
          <Routes></Routes>
        </Layout>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
